import { StateProvider } from '@uirouter/angularjs';
import { LoginController } from './login/login.controller';
/**
 * @param {StateProvider} $stateProvider 
 */
export function AccountRouting($stateProvider) {
  "ngInject";

  $stateProvider
  .state({
    name: 'login',
    url: '/login',
    template: require('./login/login.html'),
    controller: LoginController,
    controllerAs: '$ctrl',
    data: {
      pageTitle: 'Mandaê - Login'
    }
  })
}
